module.exports = __webpack_public_path__ + "img/bar-chart-line-fill.ccc657a5.svg";